import { showAlert, hideAlert } from '../redux/modules/alert';
import { positions } from '../components/kit/Alert/positions';
import { history } from '../utils';
import { store } from '../redux/store';
import { actions as profileActions } from '../redux/modules/profile';

export const handleError = (
  error,
  status = 'failure',
  position = positions.TOP_END
) => {
  if (error?.type === 'serverError')
    return store.dispatch(showAlert('عدم ارتباط با سرور!'), 'failure');

  if (error?.type === 'internet')
    return store.dispatch(showAlert('اینترنت خود را چک کنید!', 'failure'));

  // if (error?.code === 1003 || error?.data.code === 1003) { store.dispatch(showAlert(error?.data.message || error?.message, 'failure')); store.dispatch(profileActions.resetCache()); history.replace('/auth/login'); }

  if (error?.code === 1700 || error?.data?.code === 1700)
    return store.dispatch(
      showAlert(error?.data?.message || error?.message, 'failure')
    );

  if (error?.code === 1010 || error?.data?.code === 1010)
    return store.dispatch(
      showAlert(error?.data?.message || error?.message, 'failure')
    );
  // return alert(error?.message || error?.data?.message);

  if (error?.type >= 500) store.dispatch(showAlert('عدم ارتباط با سرور!'));
};
